export const AUTH_ROOT_ROUTE = "/auth";
export const FORGOT_PASSWORD_ROUTE = "/forgot-password";
export const FORGOT_PASSWORD_SUBMIT_ROUTE = "/forgot-password-submit";
export const RECOVER_PASSWORD =
  "/recover-password/:ssoId/:confirmationCode/:epoch/:confirmationToken";
export const RECOVER_PASSWORD_REDIRECT =
  "/recover_password/validate_token/:ssoId/:confirmationCode/:epoch/:confirmationToken";
export const RECOVER_JOIN_PASSWORD = "/recover-password/:token";
export const RECOVER_JOIN_PASSWORD_REDIRECT =
  "/recover_password/validate_token/:token";
export const NEW_PASSWORD_ROUTE = "/new-password";
export const LOGIN_ROUTE = "/login";
export const LOGIN_ROUTE_REDIRECT = "/session/login";
export const REGISTER_ROUTE = "/register";
export const REGISTER_ROUTE_REDIRECT = "/session/signup";
export const REGISTER_WITH_CODE_ROUTE = "/register/:code";
export const REGISTER_WITH_CODE_ROUTE_REDIRECT = "/invite/:code";
export const REGISTER_HOME_WITH_CODE_ROUTE_REDIRECT = "/home/register/:code";
export const USER_VERIFICATION_ROUTE = "/user-verification";
export const PHONE_VERIFICATION_ROUTE = "/phone-verification";
